import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PermissionStates } from '../../permission-controller/root';
import { UserPermStates } from '../states';
import { userPermAdapters, UserPermState } from '../states/user-permissions.states';

export const userPermFeatureKey = 'userPerm';

export const selectUserPermFeature = createFeatureSelector<UserPermState>(userPermFeatureKey);

export const selectNewPermSet = (state: PermissionStates) => state.permissions.userPerm.newPermSet;
export const selectPermTemplate = (state: PermissionStates) => state.permissions.userPerm.selectedPermTemplate;
export const selectCreatedPermSet = (state: PermissionStates) => state.permissions.userPerm.selectedCreatedPermSet;
export const selectCreatedPermSetLine = (state: PermissionStates) => state.permissions.userPerm.selectedCreatedPermSetLine;

export const selectCurrentUser = (state: PermissionStates) => state.permissions.userPerm.currentUser;
export const selectSelectedUser = (state: PermissionStates) => state.permissions.userPerm.selectedUser;
export const selectUpdateUserListing = (state: PermissionStates) => state.permissions.userPerm.updateUserListing;
export const selectUpdatePermSetListing = (state: PermissionStates) => state.permissions.userPerm.updatePermSetListing;

export const selectSelectedRole = (state: PermissionStates) => state.permissions.userPerm.selectedRole;
export const selectSelectedPermSet = (state: PermissionStates) => state.permissions.userPerm.selectedPermSet;
export const selectSelectedPermSetLine = (state: PermissionStates) => state.permissions.userPerm.selectedPermSetLine;

export const selectGuid = (state: PermissionStates) => state.permissions.userPerm.selectedGuid;
export const selectRequiresUpdate = (state: PermissionStates) => state.permissions.userPerm.requiresUpdate;

// This is an example of how to combine selectors
// export const combinedSelectors = createSelector(
//   selectGuid,
//   selectRemoveState,
//   (guid, onRemove) => ({guid, onRemove})
// )

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal
} = userPermAdapters.getSelectors(selectUserPermFeature);
